// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
// Entry imports
const smsModalActions = require('client-v2/into-landing/containers/sms-modal/actions')
// Sibling imports
const IntoLandingCuratedUser = require('./component-dumb')

function mapStateToProps(state) {
  return {
    isAndroid: state.env.browser.has('android'),
    isIos: state.env.browser.has('ios'),
    isDesktop: state.env.browser.has('isDesktop'),
    // Values
    baseUrl: state.env.baseUrl,
    iosDeeplinkHref: state.env.deeplinkUrls.get('ios')
  }
}

const mapDispatchToProps = {
  onFollowClick: smsModalActions.show
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    IntoLandingCuratedUser
  )
)
